import { Injectable } from '@angular/core';
import { BaseModalService } from 'src/app/shared/services/base-modal/base-modal.service';
import { CopyActivationLinkConfiguration } from './copy-activation-link-configuration.model';

@Injectable({
  providedIn: 'root'
})
export class CopyActivationModalService extends BaseModalService<CopyActivationLinkConfiguration> {}
